import { once } from '../shared/once';

export const getPlan = once<Promise<any>>(async (planId: string) => {
    const data = await fetch(`${window.mh.apiUrl}/v1/programs/${window.mh.programSlug}/plans/${planId}`, {
        method: `GET`,
    });

    if (!data.ok) {
        throw new Error(`Could not obtain plan data. Please check your network connection and refresh the page.`);
    }

    return data.json();
});
